<template>
  <v-app id="inspire" class="modern-app">
    <!-- Modern Sidebar - Outside v-layout to prevent displacement -->
    <v-navigation-drawer 
      v-model="subMenu" 
      :rail="rail" 
      :permanent="true"
      :temporary="false"
      :mobile-breakpoint="0" 
      class="modern-sidebar"
      elevation="0"
      :width="rail ? 70 : 240"
      absolute
    >
        <!-- Enhanced Logo Section -->
        <div class="logo-section">
          <div class="logo-wrapper">
            <div class="logo-container" :class="{ 'rail-mode': rail }">
              <div class="logo-background">
                <img 
                  :src="require('@/assets/logo.png')" 
                  alt="Logo" 
                  class="logo-image"
                />
                <div class="logo-glow"></div>
              </div>
            </div>
            <div v-if="!rail" class="logo-text">
              <h2 class="logo-title">AMS</h2>
              <p class="logo-subtitle">Asset Management System</p>
            </div>
          </div>
        </div>

        <!-- Navigation Menu -->
        <div class="navigation-menu">
          <!-- Dashboard -->
          <div class="nav-item" @click="navigateTo('/Dashboard')" :class="{ 'rail-item': rail }" :data-tooltip="rail ? 'Dashboard' : ''">
            <div class="nav-icon-wrapper primary-gold-dark" :class="{ 'rail-icon': rail }">
              <icon-layout-grid class="nav-icon" />
            </div>
            <span v-if="!rail" class="nav-label">Dashboard</span>
          </div>

          <!-- Section Divider -->
          <div v-if="!rail" class="section-divider">
            <span class="section-label">Articles</span>
          </div>

          <!-- Articles réceptionnés -->
          <div class="nav-item" @click="navigateTo('/Articles-receptionner')" :class="{ 'rail-item': rail }" :data-tooltip="rail ? 'Articles réceptionnés' : ''">
            <div class="nav-icon-wrapper primary-gold" :class="{ 'rail-icon': rail }">
              <icon-clipboard-text class="nav-icon" />
            </div>
            <span v-if="!rail" class="nav-label"> Nouveaux Articles</span>
          </div>

          <!-- Articles affectés -->
          <div class="nav-item" @click="navigateTo('/Articles')" :class="{ 'rail-item': rail }" :data-tooltip="rail ? 'Articles affectés' : ''">
            <div class="nav-icon-wrapper primary-gold-light" :class="{ 'rail-icon': rail }">
              <icon-tag class="nav-icon" />
            </div>
            <span v-if="!rail" class="nav-label">Articles affectés</span>
          </div>

          <!-- Section Divider -->
          <div v-if="!rail" class="section-divider">
            <span class="section-label">Inventaire</span>
          </div>

          <!-- Inventaire par site -->
          <div class="nav-item" @click="navigateTo('/Inventaire-Location')" :class="{ 'rail-item': rail }" :data-tooltip="rail ? 'Inventaire par site' : ''">
            <div class="nav-icon-wrapper primary-gold-dark" :class="{ 'rail-icon': rail }">
              <icon-home class="nav-icon" />
            </div>
            <span v-if="!rail" class="nav-label">Par site</span>
          </div>

          <!-- Inventaire par zone -->
          <div class="nav-item" @click="navigateTo('/Inventaire-zone')" :class="{ 'rail-item': rail }" :data-tooltip="rail ? 'Inventaire par zone' : ''">
            <div class="nav-icon-wrapper primary-gold" :class="{ 'rail-icon': rail }">
              <icon-folder class="nav-icon" />
            </div>
            <span v-if="!rail" class="nav-label">Par zone</span>
          </div>

          <!-- Inventaire par emplacement -->
          <div class="nav-item" @click="navigateTo('/Inventaire-emplacement')" :class="{ 'rail-item': rail }" :data-tooltip="rail ? 'Inventaire par emplacement' : ''">
            <div class="nav-icon-wrapper primary-gold-light" :class="{ 'rail-icon': rail }">
              <icon-folder class="nav-icon" />
            </div>
            <span v-if="!rail" class="nav-label">Par emplacement</span>
          </div>

          <!-- Inventaire par département -->
          <div class="nav-item" @click="navigateTo('/inventaire-departement')" :class="{ 'rail-item': rail }" :data-tooltip="rail ? 'Inventaire par département' : ''">
            <div class="nav-icon-wrapper primary-gold-dark" :class="{ 'rail-icon': rail }">
              <icon-folder class="nav-icon" />
            </div>
            <span v-if="!rail" class="nav-label">Par département</span>
          </div>

          <!-- Section Divider -->
          <div v-if="!rail" class="section-divider">
            <span class="section-label">Gestion</span>
          </div>

          <!-- Articles consommés -->
          <div class="nav-item" @click="navigateTo('/Article_consomme')" :class="{ 'rail-item': rail }" :data-tooltip="rail ? 'Articles consommés' : ''">
            <div class="nav-icon-wrapper neutral-gray" :class="{ 'rail-icon': rail }">
              <icon-trash class="nav-icon" />
            </div>
            <span v-if="!rail" class="nav-label">Articles consommés</span>
          </div>

          <!-- Articles reformés -->
          <div class="nav-item" @click="navigateTo('/Article_archive')" :class="{ 'rail-item': rail }" :data-tooltip="rail ? 'Articles reformés' : ''">
            <div class="nav-icon-wrapper primary-gold" :class="{ 'rail-icon': rail }">
              <icon-folder-minus class="nav-icon" />
            </div>
            <span v-if="!rail" class="nav-label">Articles reformés</span>
          </div>

          <!-- Section Divider -->
          <div v-if="!rail" class="section-divider">
            <span class="section-label">Configuration</span>
          </div>

          <!-- Paramétrage -->
          <div class="nav-item external" @click="openExternal('https://invtfm5.ma/admin/')" :class="{ 'rail-item': rail }" :data-tooltip="rail ? 'Paramétrage' : ''">
            <div class="nav-icon-wrapper primary-gold-dark" :class="{ 'rail-icon': rail }">
              <icon-settings class="nav-icon" />
            </div>
            <span v-if="!rail" class="nav-label">
              Paramétrage
              <icon-launch class="external-icon" />
            </span>
          </div>

        </div>
    </v-navigation-drawer>
    
    <!-- Modern Top Bar -->
    <v-app-bar 
      scroll-threshold="0" 
      class="modern-topbar"
      :class="{ 'rail-topbar': rail }"
      elevation="0"
      height="72"
    >
      <!-- Menu Toggle -->
      <div class="topbar-content">
        <button 
          @click.stop="rail = !rail"
          class="menu-toggle"
        >
          <icon-horizontal-dots class="toggle-icon" />
        </button>
        
        <!-- Title Section -->
        <div class="title-section">
          <h1 class="app-title">Système de Gestion d'Immobilisations</h1>
          <p class="app-subtitle">Plateforme de gestion moderne</p>
        </div>
        
        <!-- User Profile -->
        <v-menu open-on-hover>
          <template v-slot:activator="{ props }">
            <div v-bind="props" class="user-profile">
              <div class="user-avatar">
                <icon-user class="avatar-icon" />
              </div>
              <div class="user-info">
                <span class="user-name">Administrateur</span>
                <span class="user-role">Super Admin</span>
              </div>
              <icon-chevron-down class="dropdown-icon" />
            </div>
          </template>
          
          <div class="user-dropdown">
            <div class="dropdown-item" @click="logout">
              <div class="dropdown-icon-wrapper">
                <icon-logout class="dropdown-icon-svg" />
              </div>
              <span class="dropdown-label">Déconnexion</span>
            </div>
          </div>
        </v-menu>
      </div>
    </v-app-bar>

    <!-- Main Content Area -->
    <v-main class="bg-gray-50 main-content p-5 m-5" :class="{ 'rail-content': rail }">
      <div class="content-wrapper">
        <router-view></router-view>
      </div>
    </v-main>
    
    <!-- Footer -->
    <v-footer 
      class="modern-footer bg-white border-t border-gray-200 shadow-inner"
      :class="{ 'rail-footer': rail }"
    >
      <div class="w-full flex justify-center items-center py-3">
        <span class="text-gray-600 text-sm font-medium text-center">&copy; 2024 SM@TCH - Système de Gestion d'Immobilisations</span>
      </div>
    </v-footer>
  </v-app>
</template>

<script lang="ts">
import store from '@/store';
import { clearTokens } from '@/utils/cookieUtils';
import { defineComponent, ref, watch } from 'vue';
import { useRouter } from 'vue-router';

// Icon imports
import IconLayoutGrid from '@/components/icon/icon-layout-grid.vue';
import IconClipboardText from '@/components/icon/icon-clipboard-text.vue';
import IconTag from '@/components/icon/icon-tag.vue';
import IconHome from '@/components/icon/icon-home.vue';
import IconFolder from '@/components/icon/icon-folder.vue';
import IconFolderMinus from '@/components/icon/icon-folder-minus.vue';
import IconTrash from '@/components/icon/icon-trash.vue';
import IconSettings from '@/components/icon/icon-settings.vue';
import IconLaunch from '@/components/icon/icon-launch.vue';
import IconHorizontalDots from '@/components/icon/icon-horizontal-dots.vue';
import IconUser from '@/components/icon/icon-user.vue';
import IconChevronDown from '@/components/icon/icon-chevron-down.vue';
import IconLogout from '@/components/icon/icon-logout.vue';

export default defineComponent({
  components: {
    IconLayoutGrid,
    IconClipboardText,
    IconTag,
    IconHome,
    IconFolder,
    IconFolderMinus,
    IconTrash,
    IconSettings,
    IconLaunch,
    IconHorizontalDots,
    IconUser,
    IconChevronDown,
    IconLogout,
  },
          setup() {
          const hideSidebarText = ref(false);
          const subMenu = ref(true); // Always visible
          const rail = ref(false); // Start with expanded sidebar (reduced width)
          const router = useRouter();
          const logoHeight = ref('50px');

    watch(rail, (newValue) => {
      logoHeight.value = newValue ? '50px' : '100px';
    });

    const navigateTo = (path: string) => {
      router.push(path);
    };

    const openExternal = (url: string) => {
      window.open(url, '_blank');
    };

    const logout = async () => {
      try {
        const response = store.dispatch('AuthModule/logout');
        if (await response == 200) {
          router.push('/login')
        } else {
          clearTokens();
          router.push('/login')
        }
      }
      catch (error) {
        console.error(error);
      }
    }

    return { 
      hideSidebarText, 
      subMenu, 
      rail, 
      logout, 
      logoHeight,
      navigateTo,
      openExternal
    };
  }
});
</script>

<style>
/* Global Layout Rules - Must be unscoped */
html, body {
  min-height: 100vh !important;
  overflow-x: hidden !important; /* Empêche le scroll horizontal uniquement */
}

/* Vuetify specific overrides */
.v-application {
  min-height: 100vh !important;
  overflow-x: hidden !important;
  display: flex !important;
  flex-direction: column !important;
}

.v-application__wrap {
  min-height: 100vh !important;
  overflow-x: hidden !important;
  display: flex !important;
  flex-direction: column !important;
}

/* Main content area can scroll vertically */
.v-main__wrap {
  overflow-x: hidden !important;
  overflow-y: visible !important;
}

/* App container */
#app {
  height: 100vh !important;
  max-height: 100vh !important;
  overflow-x: hidden !important;
}
</style>

<style scoped>
/* Global App Styles */
.modern-app {
  font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif;
  overflow: hidden;
}

/* Style des scrollbars pour un look moderne */
* {
  scrollbar-width: thin;
  scrollbar-color: rgba(252, 192, 12, 0.3) transparent;
}

*::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

*::-webkit-scrollbar-track {
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background: rgba(252, 192, 12, 0.3);
  border-radius: 3px;
}

*::-webkit-scrollbar-thumb:hover {
  background: rgba(252, 192, 12, 0.5);
}

/* Modern Sidebar */
.modern-sidebar {
  background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
  border-right: 1px solid rgba(226, 232, 240, 0.8);
  box-shadow: 
    0 1px 3px rgba(0, 0, 0, 0.05),
    0 20px 25px -5px rgba(252, 192, 12, 0.08),
    0 0 0 1px rgba(0, 0, 0, 0.02);
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  position: fixed !important;
  left: 0 !important;
  top: 0 !important;
  height: 100vh !important;
  z-index: 1005 !important;
  transform: none !important;
  flex-shrink: 0 !important;
}

/* Logo Section */
.logo-section {
  padding: 10px 1.5rem;
  background: linear-gradient(135deg, #FCC00C 0%, #f59e0b 100%);
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.modern-sidebar[data-rail="true"] .logo-section {
  padding: 0.75rem 0.5rem;
}

.logo-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
  pointer-events: none;
}

.logo-wrapper {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo-container {
  position: relative;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  width: 80px;
  height: 80px;
}

.logo-container.rail-mode {
  width: 56px;
  height: 56px;
}

.logo-background {
  position: relative;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 20px;
  padding: 16px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
}

.logo-glow {
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  background: linear-gradient(45deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.1));
  border-radius: 25px;
  filter: blur(15px);
  opacity: 0.5;
  animation: pulse 3s ease-in-out infinite;
}

.logo-text {
  margin-top: 1rem;
  text-align: center;
  color: white;
}

.logo-title {
  font-size: 1.5rem;
  font-weight: 800;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.logo-subtitle {
  font-size: 0.75rem;
  font-weight: 500;
  margin: 0.25rem 0 0 0;
  opacity: 0.9;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* Navigation Menu */
.navigation-menu {
  padding: 0.75rem 0.5rem;
  height: calc(100vh - 200px);
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.modern-sidebar[data-rail="true"] .navigation-menu {
  padding: 0.25rem 0;
  text-align: left;
}

.navigation-menu::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

/* Navigation Items */
.nav-item {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  margin: 0.125rem 0;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  background: transparent;
  border: none;
  box-shadow: none;
}

.nav-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 0;
  background: linear-gradient(180deg, #FCC00C 0%, #f59e0b 100%);
  border-radius: 0 2px 2px 0;
  transition: height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.nav-item:hover {
  background: rgba(252, 192, 12, 0.05);
  padding-left: 0.875rem;
}

.nav-item:hover::before {
  height: 40%;
}

.nav-item.router-link-active {
  background: linear-gradient(135deg, #FCC00C 0%, #f59e0b 100%);
  color: white;
  box-shadow: 
    0 2px 8px rgba(252, 192, 12, 0.2),
    0 0 0 1px rgba(255, 255, 255, 0.1) inset;
  transform: translateX(0);
  padding-left: 0.875rem;
}

.nav-item.router-link-active::before {
  height: 60%;
  background: rgba(255, 255, 255, 0.3);
}

.nav-item.router-link-active .nav-icon-wrapper {
  background: rgba(255, 255, 255, 0.15) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.nav-item.router-link-active .nav-icon,
.nav-item.router-link-active .nav-label {
  color: white !important;
  font-weight: 600;
}

/* Navigation Icons */
.nav-icon-wrapper {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  color: white;
  box-shadow: 
    0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(0, 0, 0, 0.03);
}

/* Color Variants Based on Primary Gold */
.primary-gold {
  background: linear-gradient(135deg, #FCC00C 0%, #f59e0b 100%);
  box-shadow: 
    0 2px 6px rgba(252, 192, 12, 0.25),
    0 0 0 1px rgba(0, 0, 0, 0.05);
}

.primary-gold-light {
  background: linear-gradient(135deg, #fde047 0%, #FCC00C 100%);
  box-shadow: 
    0 2px 6px rgba(253, 224, 71, 0.25),
    0 0 0 1px rgba(0, 0, 0, 0.05);
}

.primary-gold-dark {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  box-shadow: 
    0 2px 6px rgba(245, 158, 11, 0.25),
    0 0 0 1px rgba(0, 0, 0, 0.05);
}

.neutral-gray {
  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
  box-shadow: 
    0 2px 6px rgba(107, 114, 128, 0.25),
    0 0 0 1px rgba(0, 0, 0, 0.05);
}

/* Rail Mode Optimizations */
.nav-item.rail-item {
  padding: 0.4rem;
  margin: 0.125rem 0;
  width: 65px;
  height: 50px;
  justify-content: flex-start;
  padding-left: 0.125rem;
  border-radius: 10px;
  position: relative;
  margin-left: 0.125rem;
}

.nav-icon-wrapper.rail-icon {
  width: 42px;
  height: 42px;
  margin-right: 0;
  margin-left: -0.125rem;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-item.rail-item .nav-icon {
  width: 22px;
  height: 22px;
  stroke-width: 2;
}

/* Rail Mode Hover Effects */
.nav-item.rail-item:hover {
  transform: scale(1.05);
  z-index: 10;
  background: rgba(252, 192, 12, 0.08);
  box-shadow: 
    0 2px 8px rgba(252, 192, 12, 0.15),
    0 0 0 1px rgba(252, 192, 12, 0.1);
}

.nav-item.rail-item:hover .nav-icon-wrapper {
  transform: scale(1.08);
}

.nav-item.rail-item.router-link-active {
  transform: scale(1.02);
  background: linear-gradient(135deg, #FCC00C 0%, #f59e0b 100%);
  box-shadow: 
    0 2px 8px rgba(252, 192, 12, 0.25),
    0 0 0 1px rgba(255, 255, 255, 0.1) inset;
}

/* Rail Mode Tooltip Effect */
.nav-item.rail-item::after {
  content: attr(data-tooltip);
  position: absolute;
  left: 55px;
  top: 50%;
  transform: translateY(-50%) scale(0.95);
  background: rgba(17, 24, 39, 0.95);
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  font-size: 0.6875rem;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1000;
  pointer-events: none;
  box-shadow: 
    0 4px 12px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.nav-item.rail-item::before {
  content: '';
  position: absolute;
  left: 53px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 6px solid rgba(17, 24, 39, 0.95);
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1000;
  pointer-events: none;
}

.nav-item.rail-item:hover::after {
  opacity: 1;
  visibility: visible;
  left: 64px;
  transform: translateY(-50%) scale(1);
}

.nav-item.rail-item:hover::before {
  opacity: 1;
  visibility: visible;
  left: 58px;
}

.nav-icon {
  width: 18px;
  height: 18px;
  transition: all 0.3s ease;
}

.nav-label {
  font-weight: 500;
  font-size: 0.8125rem;
  color: #4b5563;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: 0.01em;
}

/* Section Dividers */
.section-divider {
  margin: 0.75rem 0 0.5rem 0;
  padding: 0 0.75rem;
}

.section-label {
  font-size: 0.6875rem;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  position: relative;
}

.section-label::after {
  content: '';
  position: absolute;
  bottom: -6px;
  left: 0;
  width: 24px;
  height: 2px;
  background: linear-gradient(90deg, #FCC00C, #f59e0b);
  border-radius: 2px;
  opacity: 0.6;
}

/* External Link */
.nav-item.external .external-icon {
  width: 14px;
  height: 14px;
  margin-left: 0.5rem;
  opacity: 0.7;
}

/* Modern Top Bar */
.modern-topbar {
  background: linear-gradient(135deg, #FCC00C 0%, #f59e0b 100%);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  position: fixed !important;
  top: 0 !important;
  left: 240px !important;
  right: 0 !important;
  width: calc(100% - 240px) !important;
  z-index: 1004 !important;
  transition: left 0.4s cubic-bezier(0.4, 0, 0.2, 1), width 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-sizing: border-box !important;
  flex-shrink: 0 !important;
}

.modern-topbar.rail-topbar {
  left: 70px !important;
  width: calc(100% - 70px) !important;
  right: 0 !important;
}

.topbar-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 2rem;
}

/* Menu Toggle */
.menu-toggle {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 12px;
  padding: 0.75rem;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.menu-toggle:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.toggle-icon {
  width: 24px;
  height: 24px;
  color: white;
}

/* Title Section */
.title-section {
  flex: 1;
  margin-left: 2rem;
}

.app-title {
  font-size: 1.5rem;
  font-weight: 800;
  color: white;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.app-subtitle {
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
  font-weight: 500;
}

/* User Profile */
.user-profile {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.user-profile:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.02);
}

.user-avatar {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
}

.avatar-icon {
  width: 20px;
  height: 20px;
  color: white;
}

.user-info {
  display: flex;
  flex-direction: column;
  margin-right: 0.75rem;
}

.user-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
  line-height: 1.2;
}

.user-role {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.2;
}

.dropdown-icon {
  width: 16px;
  height: 16px;
  color: white;
  transition: transform 0.3s ease;
}

/* User Dropdown */
.user-dropdown {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  overflow: hidden;
  margin-top: 0.5rem;
  min-width: 200px;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 1px solid #f1f5f9;
}

.dropdown-item:last-child {
  border-bottom: none;
}

.dropdown-item:hover {
  background: #fef2f2;
  color: #dc2626;
}

.dropdown-icon-wrapper {
  width: 32px;
  height: 32px;
  background: #fee2e2;
  color: #dc2626;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
}

.dropdown-icon-svg {
  width: 16px;
  height: 16px;
}

.dropdown-label {
  font-weight: 600;
  color: #374151;
}

/* Animations */
@keyframes pulse {
  0%, 100% { opacity: 0.5; transform: scale(1); }
  50% { opacity: 0.8; transform: scale(1.05); }
}

/* Global Overrides */
.v-application {
  background: #f8fafc !important;
  overflow-x: hidden !important;
  overflow-y: visible !important;
}

.v-main {
  padding-top: 72px !important;
  background: #f8fafc;
  overflow-x: hidden !important;
  overflow-y: visible !important;
  padding-bottom: 0 !important;
  flex: 1 1 auto !important;
}

/* No Scroll Classes */
.no-scroll {
  overflow: hidden !important;
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

.no-scroll::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

.content-wrapper {
  overflow-y: visible !important;
  overflow-x: hidden !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
}

/* Main Content Adjustments for Fixed Sidebar */
.main-content {
  padding-left: 240px !important;
  margin-left: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

.main-content.rail-content {
  padding-left: 70px !important;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .user-info {
    display: none;
  }
  
  .app-subtitle {
    display: none;
  }
  
  .topbar-content {
    padding: 0 1rem;
  }
  
  .title-section {
    margin-left: 1rem;
  }
  
  /* Maintain fixed sidebar on tablets */
  .main-content {
    padding-left: 240px !important;
    margin-left: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
  }
  
  .main-content.rail-content {
    padding-left: 70px !important;
  }
}

@media (max-width: 768px) {
  .nav-item {
    padding: 0.5rem;
    margin: 0.125rem 0;
  }
  
  .nav-icon-wrapper {
    width: 36px;
    height: 36px;
    margin-right: 0.75rem;
  }
  
  .section-divider {
    margin: 1.5rem 0 0.75rem 0;
    text-align: center;
  }

  .section-label {
    font-size: 0.7rem;
  }
  
  /* Fixed sidebar on mobile too */
  .main-content {
    padding-left: 240px !important;
    margin-left: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
  }
  
  .main-content.rail-content {
    padding-left: 70px !important;
  }
  
  .modern-topbar {
    left: 240px !important;
    width: calc(100% - 240px) !important;
    right: 0 !important;
  }
  
  .modern-topbar.rail-topbar {
    left: 70px !important;
    width: calc(100% - 70px) !important;
    right: 0 !important;
  }
}

/* Footer styles */
.modern-footer {
  position: relative !important;
  width: calc(100% - 240px) !important;
  margin-left: 240px !important;
  z-index: 1005 !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0 !important;
  margin-top: auto !important;
}

.modern-footer.rail-footer {
  width: calc(100% - 70px) !important;
  margin-left: 70px !important;
}
</style>